import { CircularProgress, Switch } from "@material-ui/core";
import { useCallback } from "react";
import { useApartment } from "../../../graphql/hooks";

import { Apartment } from "../../../graphql/models";
import { useSnackbarMessage } from "../../../hooks";

export type ToggleApartmentShouldCompleteSurveyProps = {
  apartment: Pick<Apartment, "id" | "shouldCompleteSurvey">;
  onSetApartmentShouldCompleteSurveyChange: () => void;
};
export function ToggleApartmentShouldCompleteSurvey(
  props: ToggleApartmentShouldCompleteSurveyProps
) {
  const {
    apartment: { shouldCompleteSurvey, id },
    onSetApartmentShouldCompleteSurveyChange,
  } = props;

  const { raiseSuccessSnackbar } = useSnackbarMessage();

  const {
    setApartmentShouldCompleteSurvey,
    setApartmentShouldCompleteSurveyLoading,
  } = useApartment({
    onSetShouldApartmentCompleteSurvey() {
      raiseSuccessSnackbar("Preferenza per l'appartamento modificata");
      onSetApartmentShouldCompleteSurveyChange();
    },
  });

  const triggerSetApartmentShouldFillSurvey = useCallback(
    (v: boolean) => {
      setApartmentShouldCompleteSurvey(id, v);
    },
    [id, setApartmentShouldCompleteSurvey]
  );

  return (
    <>
      <Switch
        disabled={setApartmentShouldCompleteSurveyLoading}
        checked={shouldCompleteSurvey}
        onChange={(evt) =>
          triggerSetApartmentShouldFillSurvey(evt.target.checked)
        }
      />
      {setApartmentShouldCompleteSurveyLoading && <CircularProgress />}
    </>
  );
}
